import { gql } from '@apollo/client';

/**
 * @deprecated use strongly typed query from features/account.ts instead
 *
 * FIXME: migrate usage to the new feature-module query
 */
export const GET_CURRENT_ACCOUNT = gql`
  query getCurrentAccountLegacy {
    currentAccount {
      id
      createdOn
      name
      useNewNumber
      businessVertical
      billingIdentity {
        id
        brand
        billingOrderId
        paymentSource
      }
    }
  }
`;
